import React, { useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import usePortal from "../hooks/usePortal";
import styles from "./Modal.module.scss";

const Modal = React.forwardRef((props, ref) => {
  const { className, children, id } = props;
  const ModalComponent = usePortal(id);

  useEffect(() => {
    document.body.classList.add(styles.preventScroll);

    return () => document.body.classList.remove(styles.preventScroll);
  }, []);

  const classes = cx(styles.modal, className);
  return (
    <ModalComponent>
      <div ref={ref} className={classes}>
        {children}
      </div>
    </ModalComponent>
  );
});

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};

Modal.defaultProps = {
  id: "modal",
};

export default Modal;
